/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const minutesInHour = 60;
const minutesInDay = 24 * minutesInHour;
const minutesInWeek = 7 * minutesInDay;
const minutesInMonth = 30 * minutesInDay;

export enum TimeUnitsInMinutes {
    Hour = minutesInHour,
    Day = minutesInDay,
    Week = minutesInWeek,
    Month = minutesInMonth,
}
